import { useEffect, useRef } from 'react';

interface BackgroundVideoProps {
  visible: boolean;
}

export default function BackgroundVideo({ visible }: BackgroundVideoProps) {
  const videoRef = useRef<HTMLVideoElement>(null);

  useEffect(() => {
    const video = videoRef.current;
    if (!video) return;
    if (visible) {
      video.play().catch(() => {});
    } else {
      video.pause();
    }
  }, [visible]);

  return (
    <div className={`bg-video-wrap ${visible ? '' : 'bg-video-wrap--hidden'}`} aria-hidden>
      <video
        ref={videoRef}
        className="bg-video"
        src="/static/bg.mp4"
        loop
        muted
        playsInline
        autoPlay
      />
    </div>
  );
}
